/* eslint no-unused-vars: 0 */
import ref, { authRef, TIMESTAMP } from 'services/firebaseRef';
import { getValidUntilTime } from 'services/payment';
import {publishEvent, sendClassApprovedEvents} from "services/events";
import { withDefaultLanguageIfNotPresent } from 'helpers/i18n'
import {initialize} from "redux-form";
import {apiUrl} from "../../appConfig";
import {asyncAjax} from "services/ajax";

export const SESSION_UNARCHIVE = 'SESSION_UNARCHIVE';
export const UNAPPROVED_SESSIONS = 'UNAPPROVED_SESSIONS';
export const PAYWALL_PROFILE_LOADED = 'PAYWALL_PROFILE_LOADED';
export const PAYWALL_SESSION_APPROVE = 'PAYWALL_SESSION_APPROVE';
export const PAYWALL_SESSION_HIDE = 'PAYWALL_SESSION_HIDE';
export const PAYWALL_SESSION_FOUND = 'PAYWALL_SESSION_FOUND';
export const PAYWALL_USER_FOUND = 'PAYWALL_USER_FOUND';
export const PAYWALL_SESSION_REASSIGN = 'PAYWALL_SESSION_REASSIGN';
export const PAYWALL_FUNDEDSPOT_CANCEL = 'PAYWALL_FUNDEDSPOT_CANCEL';
export const PAYWALL_SESSION_REFUND = 'PAYWALL_SESSION_REFUND';
export const PAYWALL_SESSION_CONTRACTID_CHANGE = 'PAYWALL_SESSION_CONTRACTID_CHANGE';
export const PAYWALL_SESSION_VALIDUNTIL_CHANGE = 'PAYWALL_SESSION_VALIDUNTIL_CHANGE';
export const PAYWALL_USER_DELETED = 'PAYWALL_USER_DELETED';
export const PAYWALL_USER_TOGGLE_TESTER = 'PAYWALL_USER_TESTER_TOGGLED';
export const PAYWALL_ONHOLD_SESSIONS = 'PAYWALL_ONHOLD_SESSIONS';
export const PAYWALL_SESSION_ON_HOLD = 'PAYWALL_SESSION_ON_HOLD';
export const PAYWALL_SESSION_PROGRAM_CHANGE = 'PAYWALL_SESSION_PROGRAM_CHANGE';
export const PAYWALL_ERROR = 'PAYWALL_ERROR';

function getSessionById(sessionId) {
  return ref.child('sessions').child(sessionId)
    .once('value')
    .then(sessionRef => withDefaultLanguageIfNotPresent(sessionRef.val()));
}

function withDefaultLanguage(sessions) {
  return Object.keys(sessions)
    .reduce((a, c) => {
      a[c] = withDefaultLanguageIfNotPresent(sessions[c])
      return a;
    }, {})
}

function paywallProfileLoaded ({ userId, profileData }) {
  return {
    type: PAYWALL_PROFILE_LOADED,
    userId,
    profileData
  };
}

function bindSingleProfile (userId, refs) {
  return dispatch => {
    const profileRef = ref.child('users').child(userId);
    profileRef.on('value', snapshot => {
      const value = snapshot.val();
      if (!value) {
        return;
      }
      const { profile, createdAt } = value;
      const profileData = {
        createdAt,
        ...profile
      };
      dispatch(paywallProfileLoaded({ userId, profileData } ));
    });
    refs.profiles[userId] = profileRef;
  };
}

function unapprovedSessions (sessions) {
  return {
    type: UNAPPROVED_SESSIONS,
    sessions: withDefaultLanguage(sessions)
  };
}

function removeOnHold(sessions) {
  if (!sessions) return sessions;
  const filtered = {};
  Object.keys(sessions).forEach(sessionId => {
    if (sessions[sessionId].onHold) return;
    filtered[sessionId] = sessions[sessionId];
  });
  return filtered;
}

export function bindUnapprovedSessions (refs) {
  return dispatch => {
    const sessionsRef = ref
      .child('sessions')
      .orderByChild('pendingApproval').equalTo(true);
    refs.sessions = sessionsRef;
    refs.profiles = {};
    sessionsRef.on('value', snapshot => {
      const sessions = removeOnHold(snapshot.val());
      dispatch(unapprovedSessions(sessions));
      if (!sessions) {
        return;
      }
      Object.keys(sessions).forEach(sessionId => {
        const { userId } = sessions[sessionId];
        if (!refs.profiles[userId]) {
          dispatch(bindSingleProfile(userId, refs));
        }
      });
    });
  };
}

export function unbindUnapprovedSessions (refs) {
  return () => {
    refs.sessions.off();
    Object.keys(refs.profiles).forEach(userId => {
      refs.profiles[userId].off();
    });
  };
}

function sessionApprove ({ sessionId, contractId }) {
  return {
    type: PAYWALL_SESSION_APPROVE,
    sessionId,
    contractId
  };
}

export function approveSession ({
  sessionId,
  contractId,
  staffUserId,
  userId,
  email,
  programId,
  grade,
  divisionName,
  numberOfStudents,
  noEmail,
  language
}) {
  const validUntil = getValidUntilTime();
  return dispatch => {
    const approvedAt = TIMESTAMP;
    const updatedAt = TIMESTAMP;
    return ref.child('sessions').child(sessionId).update({
      pendingApproval: false,
      onHold: false,
      funding: 'CONTRACT',
      staffUserId,
      contractId,
      approvedAt,
      updatedAt,
      validUntil
    }).then(() => {
      sendClassApprovedEvents({
        userId, sessionId, programId, contractId, staffUserId, validUntil, noEmail, language
      });
    }).then(() => {
      return dispatch(
        sessionApprove({ sessionId, contractId })
      );
    });
  };
}

function sessionHide ({ sessionId }) {
  return {
    type: PAYWALL_SESSION_HIDE,
    sessionId
  };
}

export function hideSession ({
  sessionId,
  staffUserId,
  userId,
  email,
  programId,
  grade,
  divisionName,
  numberOfStudents,
  noEmail
}) {
  return dispatch => {
    const hiddenAt = TIMESTAMP;
    const updatedAt = TIMESTAMP;
    return ref.child('sessions').child(sessionId).update({
      pendingApproval: false,
      onHold: false,
      staffUserId,
      hiddenAt,
      updatedAt
    }).then(() => {
      return getSessionById(sessionId);
    }).then(({language}) => {
      const payload = {
        userId,
        sessionId,
        programId,
        staffUserId,
        language
      };
      if (!noEmail) {
        publishEvent(`Class Rejected Nurture Campaign Started`, payload);
      }
      publishEvent('Class Rejected', payload);
    }).then(() => {
      return dispatch(
        sessionHide({ sessionId })
      );
    });
  };
}

function sessionFound (session, user) {
  return {
    type: PAYWALL_SESSION_FOUND,
    session: withDefaultLanguageIfNotPresent(session),
    user
  };
}

export function findSession (sessionId) {
  return dispatch => {
    console.log('findSession', sessionId)
    if (!sessionId) {
      return dispatch(sessionFound());
    }
    return new Promise((resolve, reject) => {
      ref.child('sessions').orderByKey()
          .startAt(sessionId).limitToFirst(1)
          .once('child_added', snapshot => {
            if (snapshot && snapshot.key === sessionId) {
              return resolve(snapshot.val());
            }
            resolve();
          }, reject);
    }).then(session => {
      if (!session) {
        return dispatch(sessionFound());
      }
      const {...sessionValues} = session;
      const sessionWithId = {
        ...sessionValues,
        sessionId
      };
      return new Promise((resolve, reject) => {
        ref.child('users').child(sessionWithId.userId)
            .once('value', snapshot => {
              if (snapshot) {
                return resolve(snapshot.val());
              }
              reject();
            });
      }).then(user => {
        const {...userValues} = user;
        const userWithId = {
          ...userValues,
          userId: sessionWithId.userId
        };
        return dispatch(sessionFound(sessionWithId, userWithId));
      });
    });
  };
}

function userFound(user) {
  return {
    type: PAYWALL_USER_FOUND,
    user
  }
}

function getSession(sessionId) {
  return new Promise((resolve, reject) => {
    ref.child('sessions').child(sessionId)
      .once('value', snapshot => {
        if (snapshot && snapshot.key === sessionId) {
          const value = snapshot.val();
          return resolve({...value, sessionId});
        }
        resolve();
      }, reject);
  })
}

export function findUser(userId) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      ref.child('users').child(userId)
        .once('value', snapshot => {
          if (snapshot && snapshot.key === userId) {
            return resolve(snapshot.val());
          }
          resolve();
        }, reject);
    }).then(async (user) => {
      if (!user) return user;
      const promises = Object.values(user.sessions).map(getSession)
      user.sessions = await Promise.all(promises);
      return user;
    }).then(user => {
      if (!user) {
        return dispatch(userFound());
      }
      return dispatch(userFound({...user, userId}));
    });
  };
}

function sessionReAssign(sessionId, programId, oldUserId, newUserId) {
  return {
    type: PAYWALL_SESSION_REASSIGN,
    sessionId,
    programId,
    oldUserId,
    newUserId
  };
}

export function reassignSession ({sessionId, programId, oldUserId, newUserId, staffUserId, funding, contractId, language}) {
  return dispatch => {
    return ref.child('sessions').child(sessionId).update({
      userId: newUserId,
      staffUserId,
      updatedAt: TIMESTAMP
    }).then(() => {
      return ref.child('users').child(newUserId).child('sessions')
          .push(sessionId);
    }).then(() => {
      publishEvent(`Class Assigned`, {
        userId: newUserId,
        sessionId,
        programId,
        oldUserId,
        staffUserId,
        language
      });
    }).then(() => {
      return new Promise((resolve, reject) => {
        ref.child('users').child(oldUserId).child('sessions')
            .orderByValue()
            .startAt(sessionId)
            .limitToFirst(1)
            .once('child_added', snapshot => {
              snapshot.ref.remove(err => {
                if (err) return reject(err);
                resolve();
              });
            }, reject);
      });
    }).then(() => {
      publishEvent(`Class Re-Assigned`, {
        userId: oldUserId,
        sessionId,
        programId,
        newUserId,
        staffUserId,
        language
      });
    }).then(() => {
      dispatch(sessionReAssign(sessionId, programId, oldUserId, newUserId));
    });
  };
}

function fundedSpotCancel (sessionId, programId) {
  return {
    type: PAYWALL_FUNDEDSPOT_CANCEL,
    sessionId,
    programId
  };
}

export function cancelFundedSpot(sessionId, programId, userId, staffUserId) {
  return dispatch => {
    return ref.child('sessions').child(sessionId)
        .update({
          contractId: '',
          funding: 'CANCELLED',
          updatedAt: TIMESTAMP,
          staffUserId: staffUserId,
          validUntil: null
        })
        .then(() => getSessionById(sessionId))
        .then(({language}) => {
          publishEvent(`Funded Spot Cancelled`, {
            userId,
            sessionId,
            programId,
            staffUserId,
            language
          });
          return dispatch(fundedSpotCancel(sessionId, programId));
        });
  };
}

function sessionRefund(sessionId, programId) {
  return {
    type: PAYWALL_SESSION_REFUND,
    sessionId,
    programId
  };
}

export function refundSession(sessionId, sessionFunding, programId, userId, staffUserId) {
  return dispatch => {
    if (sessionFunding.toUpperCase() !== 'STRIPE') {
      return Promise.reject(new Error(`You can't refund a class with a funding of ${sessionFunding}.`));
    }
    return ref.child('sessions').child(sessionId)
        .update({
          funding: 'REFUNDED',
          updatedAt: TIMESTAMP,
          validUntil: null,
          staffUserId
        })
        .then(() => getSessionById(sessionId))
        .then(({language}) => {
          publishEvent(`Class Refunded`, {
            userId,
            sessionId,
            programId,
            staffUserId,
            language
          });
          return dispatch(sessionRefund(sessionId, programId));
        });
  };
}

function sessionContractIdChange(sessionId, programId, newContractId) {
  return {
    type: PAYWALL_SESSION_CONTRACTID_CHANGE,
    sessionId,
    programId,
    newContractId
  };
}

export function changeSessionContractId(sessionId, programId, userId, staffUserId, oldContractId, newContractId) {
  return dispatch => {
    return ref.child('sessions').child(sessionId)
        .update({
          contractId: newContractId,
          updatedAt: TIMESTAMP,
          staffUserId
        })
        .then(() => {
          publishEvent(`Class Contract ID Changed`, {
            userId,
            sessionId,
            programId,
            oldContractId: oldContractId,
            newContractId: newContractId,
            staffUserId
          });
          dispatch(sessionContractIdChange(sessionId, programId, newContractId));
        });
  };
}

function sessionValidUntilChange(sessionId, programId, newValidUntil) {
  return {
    type: PAYWALL_SESSION_VALIDUNTIL_CHANGE,
    sessionId,
    programId,
    newValidUntil
  };
}

export function changeSessionValidUntil(sessionId, programId, userId, staffUserId, oldValidUntil, newValidUntil) {
  return dispatch => {
    return ref.child('sessions').child(sessionId)
      .update({
        validUntil: newValidUntil,
        staffUserId
      })
      .then(() => {
        publishEvent('Class Valid Until Changed', {
          eventType: 'Class Valid Until Changed',
          userId,
          sessionId,
          programId,
          oldValidUntil,
          newValidUntil,
          staffUserId
        }, ['oldValidUntil', 'newValidUntil']);
        dispatch(sessionValidUntilChange(sessionId, programId, newValidUntil));
      });
  };
}

function sessionUnarchive (sessionId) {
  return {
    type: SESSION_UNARCHIVE,
    sessionId
  };
}

export function unarchiveSession({sessionId, programId, userId, staffUserId}) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      ref.child('sessions').child(sessionId).update({
        archived: null,
        pendingApproval: false,
        updatedAt: TIMESTAMP,
        archivedAt: null,
        staffUserId: staffUserId
      }, error => {
        if (error) {
          reject(error);
        } else {
          resolve();
        }
      });
    }).then(() => {
      return getSessionById(sessionId);
    }).then(({language}) => {
      publishEvent(`Class Unarchived`, {
        userId,
        sessionId,
        programId,
        staffUserId,
        language
      });
      return dispatch(
        sessionUnarchive(sessionId)
      );
    });
  };
}

export function userDeleted(userId) {
  return {
    type: PAYWALL_USER_DELETED,
    userId
  }
}

export function deleteUser({userId, staffUserId}) {
  return dispatch => {
    const userRef = ref.child('users').child(userId);
    const updatedFields = {
      firstName: 'Deleted',
      lastName: 'Deleted',
      phone: 'Deleted',
      email: 'Deleted',
      school: 'Deleted',
      cityOrMunicipality: 'Deleted',
      stateOrProvince: 'Deleted',
      country: 'Deleted'
    };
    return userRef.child('profile')
      .update(updatedFields)
      .then(() => {
        return userRef.update({
          updatedAt: TIMESTAMP,
          isDeleted: true
        })
      })
      .then(() => {
        publishEvent('User Deleted', { userId, staffUserId, ...updatedFields });
        return dispatch(userDeleted(userId))
      })
  }
}

function testerToggled(userId, staffUserId, tester) {
  return {
    type: PAYWALL_USER_TOGGLE_TESTER,
    userId,
    staffUserId,
    tester
  }
}

export function toggleTester({userId, staffUserId, tester}) {
  return dispatch => {
    return ref.child(`users/${userId}/profile`)
      .update({tester})
      .then(() => {
        if (tester) {
          publishEvent('Beta Testing Enabled', { userId, staffUserId });
        } else {
          publishEvent('Beta Testing Disabled', { userId, staffUserId });
        }
        return dispatch(testerToggled(userId, staffUserId, tester))
      })
  }
}

function onHoldSessions (sessions) {
  return {
    type: PAYWALL_ONHOLD_SESSIONS,
    sessions: withDefaultLanguage(sessions)
  };
}

export function bindOnHoldSessions (refs) {
  return dispatch => {
    const sessionsRef = ref
      .child('sessions')
      .orderByChild('onHold').equalTo(true);
    refs.sessions = sessionsRef;
    refs.profiles = {};
    sessionsRef.on('value', snapshot => {
      const sessions = snapshot.val();
      dispatch(onHoldSessions(sessions));
      if (!sessions) {
        return;
      }
      Object.keys(sessions).forEach(sessionId => {
        const { userId } = sessions[sessionId];
        if (!refs.profiles[userId]) {
          dispatch(bindSingleProfile(userId, refs));
        }
      });
    });
  };
}

export function unbindOnHoldSessions (refs) {
  return () => {
    refs.sessions.off();
    Object.keys(refs.profiles).forEach(userId => {
      refs.profiles[userId].off();
    });
  };
}

function sessionOnHold(sessionId) {
  return {type: PAYWALL_SESSION_ON_HOLD, sessionId}
}

export function putOnHold({sessionId}) {
  return dispatch => {
    return ref.child(`sessions/${sessionId}`).update({onHold: true})
      .then(() => {
        return dispatch(sessionOnHold(sessionId));
      });
  }
}

function sessionProgramChange(sessionId, oldProgramId, newProgramId, userId) {
  return {type: PAYWALL_SESSION_PROGRAM_CHANGE, sessionId, oldProgramId, newProgramId, userId}
}

export function changeProgram({sessionId, oldProgramId, newProgramId, userId}) {
  return dispatch => {
    return ref.child(`sessions/${sessionId}`).update({programId: newProgramId})
      .then(() => {
        publishEvent('Program Changed', { userId, sessionId, oldProgramId, newProgramId });
      })
      .then(() => {
        return dispatch(sessionProgramChange(sessionId, oldProgramId, newProgramId, userId))
      })
  }
}

export function resetEditUserForm (values = {}) {
  return dispatch => {
    dispatch(initialize('editUser', values));
    dispatch(paywallError(''));
  };
}

function paywallError(message) {
  return {
    type: PAYWALL_ERROR,
    message
  }
}

export function editUser (userId, values, { staffUserId }) {
  return dispatch => {
    const profileRef = ref.child(`users/${userId}/profile`);
    let previousProfile = null
    return profileRef.once('value')
      .then(snapshot => {
        previousProfile = snapshot.val();
        return profileRef.update(values);
      })
      .then(() => {
        // if email has changed we need to ask the API to update the authentication
        if (previousProfile.email !== values.email) {
          return asyncAjax(apiUrl + 'updateEmail', JSON.stringify({ userId }))
            .then((arg) => {
              /** @type {XMLHttpRequest} */
              const xhr = arg
              if (xhr.status !== 200) {
                throw new Error(['Error talking with API:', xhr.status, xhr.statusText].join(' '));
              }
              const result = JSON.parse(xhr.responseText);
              const { error } = result;
              if (error) {
                throw new Error(['Could not update email:', error].join(' '));
              }
            })
            .catch((error) => {
              dispatch(paywallError(error.message));
              // rollback email change
              return profileRef.update({ email: previousProfile.email });
            })
        }
      })
      .then(() => {
        return ref.child(`users/${userId}`)
          .update({ updatedAt: TIMESTAMP });
      })
      .then(() => {
        publishEvent('Profile Updated', {
          userId,
          staffUserId,
          email: values.email,
          firstName: previousProfile.firstName,
          lastName: previousProfile.lastName,
          phone: previousProfile.phone,
          country: values.country,
          stateOrProvince: values.stateOrProvince,
          cityOrMunicipality: values.cityOrMunicipality,
          school: previousProfile.school,
          marketingOptIn: previousProfile.marketingOptIn,
          gettingStartedOptIn: previousProfile.gettingStartedOptIn,
          directPromotionOptIn: previousProfile.directPromotionOptIn
        });
        if (previousProfile.tester !== values.tester) {
          if (values.tester) {
            publishEvent('Beta Testing Enabled', {userId, staffUserId});
          } else {
            publishEvent('Beta Testing Disabled', {userId, staffUserId});
          }
          return dispatch(testerToggled(userId, staffUserId, values.tester))
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/paywallActions.js